module.exports = __webpack_public_path__ + "img/29.2814bcc1.jpg";